import * as React from "react";

import AppPage from "@/ui/AppPage/AppPage";
import UsersTable from "@/views/Administration/UsersPage/UsersTable";

import Box from '@mui/material/Box';

function AppUsersPage() {
  return (
    <AppPage>
      <Box m={2}>
        <UsersTable />
      </Box>
    </AppPage>
  );
}

export default AppUsersPage;